import backgroundStyles from './Background.scss';
export var gradientToClassName = function (gradient) {
    return gradient === undefined ? '' : backgroundStyles["gradient-type-".concat(gradient)];
};
export var rgba = function (hexColor, opacity) {
    if (opacity === void 0) { opacity = 1; }
    var r = 0, g = 0, b = 0;
    // #XXX
    if (hexColor.length === 4) {
        r = parseInt("".concat(hexColor[1]).concat(hexColor[1]), 16);
        g = parseInt("".concat(hexColor[2]).concat(hexColor[2]), 16);
        b = parseInt("".concat(hexColor[3]).concat(hexColor[3]), 16);
        // #XXXXXX
    }
    else if (hexColor.length === 7) {
        r = parseInt("".concat(hexColor[1]).concat(hexColor[2]), 16);
        g = parseInt("".concat(hexColor[3]).concat(hexColor[4]), 16);
        b = parseInt("".concat(hexColor[5]).concat(hexColor[6]), 16);
    }
    var a = Math.max(0, Math.min(1, opacity));
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};
//# sourceMappingURL=utils.js.map